/**
 * Non-blocking background warm of the local album index while Home is visible.
 * Chunked loadLocalAlbumIndex — never awaited on the Home render path.
 */
import { isConnectorAvailable } from '../lib/connector';
import { isLocalAlbumIndexWarm, loadLocalAlbumIndex } from './libraryAlbumIndex';
import { shouldUseLocalLibraryIpc } from './localLibraryIpcGate';

export function maybeWarmHomeLibraryIndex(): void {
  if (!isConnectorAvailable() || !shouldUseLocalLibraryIpc()) return;
  if (isLocalAlbumIndexWarm()) return;
  void loadLocalAlbumIndex().catch((err) => {
    console.warn('[home] background library index warm failed:', err);
  });
}
